import { getGodModeOptionsState } from '@mote/helpers/identity'
import { useGenericRequestHandler } from '../../../handlers'
import type { GenericHandlerValues, LoopsDTO } from '../../../models'

export type UseMyLoopsMutationValues = GenericHandlerValues<LoopsDTO, 'POST'>

export function useMyLoopsMutation(): UseMyLoopsMutationValues {
  const godModeState = getGodModeOptionsState()

  return useGenericRequestHandler({
    route: `v1/a/loops`,
    method: 'POST',
    options: {
      json: godModeState.options,
      shouldNotStoreAuthData: godModeState.inGodMode
    }
  }) as UseMyLoopsMutationValues
}
